export default "/assets/site/images/hero.png?32700ea69731e1937e4df9cb4595695d";